// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.space {
  margin-bottom: 5% !important;
}

.ng-select.mat-form-field {
  width: 100%;
  margin: -2px 0px;
}

::ng-deep .ng-select-single .ng-select-container:not(.containerMultiline) .ng-value-container .ng-input {
  width: calc(100% - 90px) !important;
}

::ng-deep .multiline-lookup.ng-select.ng-select-single .ng-select-container .ng-value-container {
  white-space: pre-wrap !important;
}

::ng-deep .multiline-lookup.ng-select.ng-select-single .ng-select-container .ng-value-container .ng-value {
  white-space: pre-wrap !important;
}

::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items .ng-option {
  white-space: unset !important;
  border-top: 1px solid lightgrey !important;
}

::ng-deep .multiline-lookup.ng-select.ng-select-opened .ng-value {
  height: 15px !important;
}

::ng-deep ng-select.ng-invalid.ng-touched .ng-select-container .ng-value-container .ng-placeholder {
  color: red;
}

::ng-deep ng-select.ng-invalid.ng-touched .ng-arrow-wrapper .ng-arrow {
  color: red;
}

::ng-deep ng-select.ng-invalid.ng-touched .ng-select-container {
  box-shadow: 0 3px 1px -2px red;
}`, "",{"version":3,"sources":["webpack://./src/app/directives/eqp-lookup/eqp-lookup.component.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAGA;EACE,gCAAA;AAAF;;AAIA;EACE,gCAAA;AADF;;AAIA;EACE,6BAAA;EACA,0CAAA;AADF;;AAIA;EACE,uBAAA;AADF;;AAGA;EACE,UAAA;AAAF;;AAEA;EACE,UAAA;AACF;;AACA;EACE,8BAAA;AAEF","sourcesContent":[".space {\r\n  margin-bottom: 5% !important;\r\n}\r\n\r\n.ng-select.mat-form-field {\r\n  width: 100%;\r\n  margin: -2px 0px;\r\n}\r\n\r\n::ng-deep .ng-select-single .ng-select-container:not(.containerMultiline) .ng-value-container .ng-input{\r\n  width: calc(100% - 90px) !important;\r\n}\r\n\r\n\r\n::ng-deep .multiline-lookup.ng-select.ng-select-single .ng-select-container .ng-value-container{\r\n  white-space: pre-wrap !important;\r\n}\r\n\r\n\r\n::ng-deep .multiline-lookup.ng-select.ng-select-single .ng-select-container .ng-value-container .ng-value{\r\n  white-space: pre-wrap !important;\r\n}\r\n\r\n::ng-deep .ng-dropdown-panel .ng-dropdown-panel-items .ng-option {\r\n  white-space: unset !important;\r\n  border-top: 1px solid lightgrey !important;\r\n  }\r\n\r\n::ng-deep .multiline-lookup.ng-select.ng-select-opened .ng-value {\r\n  height: 15px !important\r\n}\r\n::ng-deep ng-select.ng-invalid.ng-touched .ng-select-container .ng-value-container .ng-placeholder {\r\n  color: red;\r\n}\r\n::ng-deep ng-select.ng-invalid.ng-touched .ng-arrow-wrapper .ng-arrow {\r\n  color: red;\r\n}\r\n::ng-deep ng-select.ng-invalid.ng-touched .ng-select-container {\r\n  box-shadow: 0 3px 1px -2px red;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
